import React from 'react';
import { useAuth } from '../context/AuthContext';

/**
 * Renders children only if the current user has the specified permission.
 *
 * Usage:
 *   <Can module="sales" action="delete">
 *     <button onClick={onDelete}>Delete</button>
 *   </Can>
 *
 *   <Can module="sales" action="delete" fallback={<span>No access</span>}>
 *     <button>Delete</button>
 *   </Can>
 *
 *   // Disable (don't hide) with function-child:
 *   <Can module="sales" action="delete">
 *     {(allowed) => (
 *       <button disabled={!allowed} onClick={onDelete}>Delete</button>
 *     )}
 *   </Can>
 */
export default function Can({ module, action, fallback = null, children }) {
  const { can } = useAuth();
  const allowed = can(module, action);

  // Function-child pattern: always renders, passes bool to child
  if (typeof children === 'function') {
    return children(allowed);
  }

  if (!allowed) return fallback;
  return <>{children}</>;
}
